module.exports = __webpack_public_path__ + "img/recharge_go-ar.0d9184bb.png";